import {
  Box,
  Flex,
  Grid,
  Input,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  useBreakpointValue,
  IconButton,
  Badge,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Tab,
  Button,
  Textarea,
  FormControl,
  FormLabel,
  Spinner,
  GridItem,
  Text,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "AppProvider/AppContext";
import FileViewer from "components/common/FileViewerPdfAndImage/FileViewer";
import EmergingForm from "./element/emergingForm";
import { appRequest } from "routes";
import { PDFDocument } from "pdf-lib";
import { emergingRequiredFields } from "./element/constant";
import { customDecimalRoundSafe } from "../common/function";

const DOC_SLOTS = [
  { key: "agreement", label: "Agreement Document", required: true },
  { key: "supportingDocument", label: "Supporting Documents", required: true }
];

/* ================= HELPERS ================= */
const base64ToBlob = (base64: string, contentType: string = "") => {
  const byteCharacters = atob(base64);
  const byteArrays = [];
  const sliceSize = 512 * 1024;

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
};

/* ================= FIELD MAPPER ================= */
const makeField = (original: any, edited: any) => {
  // Deep comparison for arrays/objects
  const isDifferent = JSON.stringify(original) !== JSON.stringify(edited);
  return {
    originalValue: original ?? "",
    editFieldValue: edited !== undefined && isDifferent ? edited : null,
  };
};

export default function EmergingProcess({
  file,
  isOpen,
  onClose,
  item,
  documentId,
  newData = false,
  handleGet,
  name,
  docId,
  activePage,
  asInitiator
}: any): JSX.Element {
  let level = 4;

  const { toastNotify, accountDetails, workflowProcess, workFlowData } =
    useContext(AppContext);
  const viewerWidth = useBreakpointValue({ lg: true });
  const width = file ? "97vw" : "95vw";

  /* ================= FILE STATE ================= */
  const [fileSlots, setFileSlots] = useState<Record<string, File | null>>({
    agreement: null,
    supportingDocument: null,
    other: null,
  });

  const [sample, setSample] = useState<any>({
    url: "",
    file: null as any,
    type: null,
    buffer: null,
    base64: null as string | null,
  });


  const [fetchFileLoader, setFetchFileLoader] = useState(false);
  const [previews, setPreviews] = useState<Record<string, string | null>>({
    agreement: null,
    supportingDocument: null,
    other: null,
  });

  console.log("the file are", file)
  console.log('the ample are', sample)

  /* ================= MASTER DOCUMENT MODAL LOGIC REMOVED ================= */

  /* ================= FORM DATA ================= */
  const [invoiceDetails, setInvoiceDetails] = useState<any>({});
  const [originalDetails, setOriginalDetails] = useState<any>({});

  /* ================= DECISION ================= */
  const [decisionDrawerOpen, setDecisionDrawerOpen] = useState(false);
  const [decisionType, setDecisionType] = useState<"approved" | "rejected">(
    "approved",
  );
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState<Record<string, string>>({});
  const [isExpanded, setIsExpanded] = useState(false); // Toggle state for file viewer



  /* ================= FILE HANDLERS ================= */
  const handleSlotChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    key: string,
  ) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;

    setFileSlots((prev) => ({ ...prev, [key]: selectedFile }));

    const fileURL = URL.createObjectURL(selectedFile);
    setPreviews((prev) => ({ ...prev, [key]: fileURL }));
  };

  const removeFile = (key: string) => {
    if (previews[key] && previews[key]?.startsWith("blob:")) {
      URL.revokeObjectURL(previews[key]!);
    }
    setFileSlots((prev) => ({ ...prev, [key]: null }));
    setPreviews((prev) => ({ ...prev, [key]: null }));
  };

  /* ================= BUILD WORKFLOW PAYLOAD ================= */
  const buildFieldsPayload = () => ({
    region: makeField(originalDetails.region, invoiceDetails.region),
    Company_Code: makeField(originalDetails.companyCode, invoiceDetails.companyCode),
    Buyer_Name: makeField(originalDetails.buyerName, invoiceDetails.buyerName),
    Buyer_GSTIN_OR_Tax_Identification_Number: makeField(originalDetails.buyerGstIn, invoiceDetails.buyerGstIn),
    Vendor_Code: makeField(originalDetails.vendorCode, invoiceDetails.vendorCode),
    Vendor_Name: makeField(originalDetails.vendorName, invoiceDetails.vendorName),
    Vendor_Address: makeField(originalDetails.vendorAddress, invoiceDetails.vendorAddress),
    Vendor_GSTIN_OR_Tax_Identification_Number: makeField(originalDetails.vendorGstIn, invoiceDetails.vendorGstIn),
    paymentTerm: makeField(originalDetails.paymentTerm, invoiceDetails.paymentTerm),
    paymentTermDesc: makeField(originalDetails.paymentTermDesc, invoiceDetails.paymentTermDesc),
    Invoice_Number: makeField(originalDetails.Invoice_Number, invoiceDetails.Invoice_Number),
    Invoice_Date: makeField(originalDetails.Invoice_Date, invoiceDetails.Invoice_Date),
    Grand_Total: makeField(originalDetails.Grand_Total, invoiceDetails.Grand_Total),
    Invoice_Type: makeField(originalDetails.invoiceType, invoiceDetails.invoiceType),
    Currency: makeField(originalDetails.currency, invoiceDetails.currency),
    Header_Text: makeField(originalDetails.headerText, invoiceDetails.headerText),
    Vendor_Text: makeField(originalDetails.vendorText, invoiceDetails.vendorText),
    postingDate: makeField(originalDetails.postingDate, invoiceDetails.postingDate),
    roundOff: makeField(originalDetails.roundOff, invoiceDetails.roundOff),
    file_name: makeField(originalDetails.file_name, invoiceDetails.file_name),
    inv_id: makeField(originalDetails.inv_id, invoiceDetails.inv_id),
    start_time: makeField(originalDetails.start_time, invoiceDetails.start_time),
    Line_Items: makeField(originalDetails.lineItems, (invoiceDetails.lineItems || []).map((li: any) => ({
      ...li,
      taxCode: li.tdsTaxCode, // fallback for legacy if any
    }))),
  });

  const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const chunkSize = 0x8000;

    for (let i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
    }

    return btoa(binary);
  };

  const mergeAllFilesToBase64 = async (files: (File | string)[]) => {
    const mergedPdf = await PDFDocument.create();

    for (const file of files) {
      let bytes: ArrayBuffer;
      if (typeof file === "string") {
        const binaryString = atob(file);
        const len = binaryString.length;
        const u8 = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          u8[i] = binaryString.charCodeAt(i);
        }
        bytes = u8.buffer;
      } else {
        if (file.type !== "application/pdf") continue;
        bytes = await file.arrayBuffer();
      }

      const pdf = await PDFDocument.load(bytes);
      const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
      pages.forEach((p) => mergedPdf.addPage(p));
    }
    const mergedBytes: any = await mergedPdf.save();
    return `${arrayBufferToBase64(mergedBytes)}`;
  };

  /* ================= ITEM VALUES → FORM HELPERS ================= */

  /**
   * Flattens a raw line-items array where each row's fields are wrapped as
   * { originalValue, editFieldValue }. Preserves line_item_id.
   * Handles both plain objects (already flat) and wrapped ones.
   */
  const flattenLineItems = (rawItems: any[]): any[] => {
    if (!Array.isArray(rawItems)) return [];
    return rawItems.map((item: any) => {
      const flat: any = {};
      Object.keys(item).forEach((key) => {
        const cell = item[key];
        if (cell && typeof cell === "object" && ("originalValue" in cell || "editFieldValue" in cell)) {
          flat[key] =
            cell.editFieldValue !== null && cell.editFieldValue !== undefined
              ? cell.editFieldValue
              : (cell.originalValue ?? "");
        } else {
          // already a plain value
          flat[key] = cell;
        }
      });
      return flat;
    });
  };

  const getLatestWorkflowValues = (valuesArray: any[] = []) => {
    if (!Array.isArray(valuesArray) || valuesArray.length === 0) return {};

    const latest = valuesArray[valuesArray.length - 1];
    const valuesObj = latest?.values || {};
    const fields = valuesObj.fields || {};
    const result: any = {};

    Object.keys(fields).forEach((key) => {
      const { originalValue, editFieldValue } = fields[key] || {};
      result[key] =
        editFieldValue !== null && editFieldValue !== undefined
          ? editFieldValue
          : (originalValue ?? "");
    });

    // Support both flat lineItems and nested tables.Invoice_line_Items
    const rawLineItems =
      valuesObj.lineItems ||
      valuesObj.tables?.Invoice_line_Items ||
      [];
    result.Line_Items = flattenLineItems(rawLineItems);

    return result;
  };

  /**
   * Converts DD.MM.YYYY or DD/MM/YYYY → YYYY-MM-DD for HTML date inputs.
   * Returns the original string if already ISO or unrecognised.
   */
  const normalizeDateToISO = (raw: string): string => {
    if (!raw) return "";
    // Match DD.MM.YYYY or DD/MM/YYYY
    const match = raw.match(/^(\d{2})[./](\d{2})[./](\d{4})$/);
    if (match) return `${match[3]}-${match[2]}-${match[1]}`;
    return raw; // already YYYY-MM-DD or other
  };

  /**
   * Wraps a plain currency string (e.g. "USD") into { value, label }
   * so the select input can display it. Passes through if already an object.
   */
  const normalizeCurrency = (raw: any): any => {
    if (!raw) return "";
    if (typeof raw === "object") return raw;
    return { value: raw, label: raw };
  };

  const mapWorkflowValuesToForm = (v: any = {}) => ({
    region: v.region || "na",
    companyCode: v.Company_Code || null,
    buyerName: v.Buyer_Name || "",
    buyerGstIn: v.Buyer_GSTIN_OR_Tax_Identification_Number || "",
    vendorCode: v.Vendor_Code || "",
    vendorName: v.Vendor_Name || "",
    vendorAddress: v.Vendor_Address || "",
    vendorGstIn: v.Vendor_GSTIN_OR_Tax_Identification_Number || "",
    paymentTerm: v.paymentTerm || "",
    paymentTermDesc: v.paymentTermDesc || "",
    Invoice_Number: v.Invoice_Number || "",
    Invoice_Date: normalizeDateToISO(v.Invoice_Date || ""),
    Grand_Total: v.Grand_Total || v.Invoice_Amount || "",
    invoiceType: v.Invoice_Type || null,
    currency: normalizeCurrency(v.Currency),
    headerText: v.Header_Text || "",
    vendorText: v.Vendor_Text || "",
    postingDate: v.postingDate || v.Posting_Date || "",
    roundOff: v.roundOff || "0.00",
    file_name: v.file_name || file?.filename || file?.metadata?.filename || "",
    inv_id: v.inv_id || "",
    start_time: v.start_time || new Date().toLocaleString(),
    lineItems: (v.Line_Items || []).map((item: any) => ({
      ...item,
      glAmount: item.glAmount !== undefined ? item.glAmount : (item.Line_Amount || ""),
      lineNarration: item.lineNarration !== undefined ? item.lineNarration : (item.Item_Description || ""),
      tdsTaxCode: item.tdsTaxCode !== undefined ? item.tdsTaxCode : (item.taxCode || null),
    }))
  });

  /* ================= PREFILL FORM FROM ITEM VALUES ================= */
  useEffect(() => {
    if (item?.values?.length) {
      const latestValues = getLatestWorkflowValues(item.values);
      const mappedForm = mapWorkflowValuesToForm(latestValues);

      setInvoiceDetails(mappedForm);
      setOriginalDetails(mappedForm);
    }
  }, [item]);

  /* ================= SUBMIT DECISION ================= */
  const submitDecision = async (decision: "yes" | "no") => {
    try {
      setLoading(true);

      const globalMandatoryFields = [
        { key: "region", label: "Region" },
        { key: "companyCode", label: "Company Code" },
        { key: "buyerName", label: "Buyer Name" },
        { key: "vendorCode", label: "Vendor Code" },
        { key: "vendorName", label: "Vendor Name" },
        { key: "vendorAddress", label: "Vendor Address" },
        { key: "Invoice_Number", label: "Invoice Number" },
        { key: "Invoice_Date", label: "Invoice Date" },
        { key: "Grand_Total", label: "Grand Total" },
        { key: "invoiceType", label: "Invoice Type" },
        { key: "currency", label: "Currency" },
        { key: "headerText", label: "Header Text" },
        { key: "vendorText", label: "Vendor Text" },
      ];

      if (decisionType === "approved") {
        const typeObj = invoiceDetails?.invoiceType;
        const invType = typeof typeObj === "object" ? typeObj?.value : typeObj;
        const isKG = invType === "KG";

        let totalGlAmount = 0;
        let totalVatAmount = 0;
        let totalWhtAmount = 0;
        let lineItemDetails = "";

        (invoiceDetails.lineItems || []).forEach((item: any, index: number) => {
          let gl = parseFloat(String(item.glAmount || "0").replace(/,/g, ""));
          let vat = parseFloat(String(item.vatAmount || "0").replace(/,/g, ""));
          let wct = parseFloat(String(item.wctAmount || "0").replace(/,/g, ""));

          gl = isNaN(gl) ? 0 : Math.abs(gl);
          vat = isNaN(vat) ? 0 : Math.abs(vat);
          wct = isNaN(wct) ? 0 : Math.abs(wct);

          totalGlAmount += gl;
          totalVatAmount += vat;
          totalWhtAmount += wct;

          lineItemDetails += `L${index + 1}: GL ${gl.toFixed(2)} | VAT ${vat.toFixed(2)} | WHT ${wct.toFixed(2)}\n`;
        });

        const rawGrandTotal = parseFloat(String(invoiceDetails.Grand_Total || "0").replace(/,/g, ""));
        const invoiceAmt = isNaN(rawGrandTotal) ? 0 : Math.abs(rawGrandTotal);

        const vendorAmt = invoiceAmt - totalWhtAmount;
        let roundOffVal = 0;

        if (isKG) {
          roundOffVal = (vendorAmt + totalWhtAmount) - (totalGlAmount + totalVatAmount);
        } else {
          roundOffVal = (totalGlAmount + totalVatAmount) - (vendorAmt + totalWhtAmount);
        }

        roundOffVal = customDecimalRoundSafe(roundOffVal);
        const isValid = roundOffVal >= -1 && roundOffVal <= 1;

        const alertMessage = `Round Off Calculation (${invType || "KR"}):
${lineItemDetails}----------------------
Invoice Total: ${invoiceAmt.toFixed(2)}
Total EXP (GL): ${totalGlAmount.toFixed(2)}
Total VAT: ${totalVatAmount.toFixed(2)}
Total WHT: ${totalWhtAmount.toFixed(2)}
Vendor Amount: ${vendorAmt.toFixed(2)}
----------------------
Formula: (GL + VAT) - (VendorAmt + WHT)
Round Off: ${roundOffVal.toFixed(2)}`;

        if (!isValid) {
          window.alert(`${alertMessage}\n\nERROR: Round Off must be between -1 and 1. Submission stopped.`);
          setLoading(false);
          return;
        } else {
          window.alert(`${alertMessage}\n\nSUCCESS: Round Off is valid. Proceeding with submission...`);
        }

        const newErrors: Record<string, string> = {};
        const missingGlobalFields = globalMandatoryFields.filter((field) => {
          const value = invoiceDetails?.[field.key];
          const actualValue = (typeof value === 'object' && value !== null && 'value' in value) ? value.value : value;
          const isMissing = actualValue === "" || actualValue === null || actualValue === undefined;
          if (isMissing) newErrors[field.key] = `${field.label} is required`;
          return isMissing;
        });

        if (missingGlobalFields.length > 0) {
          setValidationErrors(newErrors);
          toastNotify({
            title: "Validation Error",
            message: `Please fill all mandatory fields.`,
            type: "error",
          });
          setLoading(false);
          return;
        }

        // Validate Line Items
        const lineItems = invoiceDetails?.lineItems || [];
        if (lineItems.length === 0) {
          toastNotify({ title: "Validation Error", message: "Please add at least one line item.", type: "error" });
          setLoading(false);
          return;
        }

        for (let i = 0; i < lineItems.length; i++) {
          const item = lineItems[i];
          const missingLineFields = [];
          if (!item.profitCenter) missingLineFields.push("Profit Center");
          if (!item.costCenter) missingLineFields.push("Cost Center");
          if (!item.businessArea) missingLineFields.push("Business Area");
          if (!item.drCrIndicator) missingLineFields.push("Dr/Cr");
          if (!item.lineNarration) missingLineFields.push("Line Narration");
          if (!item.glAccount) missingLineFields.push("GL Account");
          if (!item.internalOrder) missingLineFields.push("Internal Order");
          if (!item.remark) missingLineFields.push("Remark");
          if (!item.glAmount) missingLineFields.push("GL Amount");
          if (!item.vatPercentage) missingLineFields.push("VAT %");

          if (missingLineFields.length > 0) {
            toastNotify({
              title: "Validation Error",
              message: `Line Item ${i + 1}: Please fill required fields.`,
              type: "error",
            });
            setLoading(false);
            return;
          }
        }
        setValidationErrors({});
      }

      if (asInitiator) {
        const files = Object.values(fileSlots).filter((f): f is File => !!f);


        let mergedFiles = null;
        let uploadedFileId = null;

        const mergeList: (File | string)[] = [];
        if (asInitiator && sample.base64) {
          mergeList.push(sample.base64);
        }
        files.forEach(f => mergeList.push(f));

        if (mergeList.length) {
          mergedFiles = await mergeAllFilesToBase64(mergeList);
          if (mergedFiles) {
            const CHUNK_SIZE = 1.5 * 1024 * 1024;
            const totalChunks = Math.ceil(mergedFiles.length / CHUNK_SIZE);
            const uploadId = `upload_${accountDetails?._id || "anon"}_${Date.now()}_${Math.random().toString(36).substring(7)}`;

            for (let i = 0; i < totalChunks; i++) {
              const start = i * CHUNK_SIZE;
              const end = Math.min(start + CHUNK_SIZE, mergedFiles.length);
              const chunk = mergedFiles.slice(start, end);

              const chunkResponse: any = await appRequest("document", "uploadChunk", {
                uploadId,
                chunkIndex: i,
                totalChunks,
                chunkData: chunk,
                filename: "attachments.pdf",
                contentType: "application/pdf"
              });

              if (chunkResponse?.status === "success" && chunkResponse?.fileId) {
                uploadedFileId = chunkResponse.fileId;
              } else if (chunkResponse?.status === "error") {
                setLoading(false);
                toastNotify({
                  title: "Upload Failed",
                  message: chunkResponse.message || "Failed to upload file chunk",
                  type: "error"
                });
                return;
              }
            }
          }
        }

        const fieldsPayload: any = buildFieldsPayload();
        const { Line_Items, ...fieldsWithoutLines } = fieldsPayload;

        const payload = {
          comment,
          activeWorkflow: workFlowData?._id,
          processName: workflowProcess?.processName,
          processType: workflowProcess?.processType,
          approveDoc: true,
          documentId: item?.documentId,
          originalValues: {
            ...invoiceDetails,
            currency: invoiceDetails?.currency?.value || invoiceDetails?.currency,
            region: invoiceDetails?.region?.value || invoiceDetails?.region,
            companyCode: invoiceDetails?.companyCode?.value || invoiceDetails?.companyCode,
            vendorCode: invoiceDetails?.vendorCode?.value || invoiceDetails?.vendorCode,
            paymentTerm: invoiceDetails?.paymentTerm,
            paymentTermDesc: invoiceDetails?.paymentTermDesc,
            Invoice_Date: invoiceDetails?.Invoice_Date,
            Invoice_Number: invoiceDetails?.Invoice_Number,
            Grand_Total: invoiceDetails?.Grand_Total,
            invoiceType: invoiceDetails?.invoiceType?.value || invoiceDetails?.invoiceType,
            tdsSectionType: invoiceDetails?.tdsSectionType?.value || invoiceDetails?.tdsSectionType,
            buyerName: invoiceDetails?.buyerName,
            roundOff: invoiceDetails?.roundOff,
            file_name: invoiceDetails?.file_name,
            inv_id: invoiceDetails?.inv_id,
            start_time: invoiceDetails?.start_time,
          },
          editedValues: null,
          finalValues: invoiceDetails,
          values: {
            valuesData: {
              fields: fieldsWithoutLines,
              lineItems: invoiceDetails?.lineItems || [],
            },
          },
          fileId: uploadedFileId || undefined,
          tags: { extraction: { type: "Automatic" } },
        };

        const missingFields = globalMandatoryFields.filter((f) => !String(payload.originalValues?.[f.key] || "").trim());
        if (missingFields.length) {
          toastNotify({
            title: "Missing Required Fields",
            message: `Please fill: ${missingFields.map((f) => f.label).join(", ")}`,
            type: "error",
          });
          setLoading(false);
          return;
        }

        const response: any = await appRequest("document", "createEmergingDoc", payload);
        if (response?.status === "success") {
          toastNotify({ title: "Success", message: "Decision submitted successfully", type: "success" });
          if (onClose) {
            if (handleGet) handleGet();
            onClose();
          }
          setDecisionDrawerOpen(false);
          setComment("");
        } else {
          toastNotify({ title: "Error", message: response?.data || "Failed to Upload the Document", type: "error" });
        }
      } else {
        const fieldsPayload: any = buildFieldsPayload();
        const { Line_Items, ...fieldsWithoutLines } = fieldsPayload;

        const updatedStatus = {
          id: item?._id,
          level: accountDetails?.level,
          status: decisionType,
          comment: comment,
          values: {
            fields: { ...fieldsWithoutLines, postingDate: { originalValue: new Date(), editFieldValue: null }, Posting_Date: { originalValue: new Date(), editFieldValue: null } },
            lineItems: invoiceDetails?.lineItems || [],
          },
          activeWorkflow: workFlowData?._id,
        };

        const response: any = await appRequest("document", accountDetails?.level === "admin" ? "updateByAdmin" : "update", updatedStatus);
        if (response?.status !== "success") throw new Error(response?.message || "Failed to update document");

        if (onClose) {
          onClose();
          if (handleGet) handleGet();
        }
        toastNotify({ title: "Success", message: response?.message || "Updated successfully", type: "success" });
        setDecisionDrawerOpen(false);
        setComment("");
      }
    } catch (err: any) {
      toastNotify({ title: "Error", message: err?.message || "Failed to submit decision", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const getFile = async () => {
    try {
      if (file?._id && item) {
        setFetchFileLoader(true);
        const response: any = await appRequest("document", "previewDocument", { fileId: file?._id });
        if (response && response.base64) {
          const contentType = response.contentType || file.metadata?.contentType || "application/pdf";
          const blob = base64ToBlob(response.base64, contentType);
          const fileURL = URL.createObjectURL(blob);
          setSample({ url: fileURL, file: file, type: contentType, buffer: null, base64: response.base64 });
        }
      }
    } catch (error: any) {
      toastNotify({ title: "Error", message: error.message, type: "error" });
    } finally {
      setFetchFileLoader(false);
    }
  };

  useEffect(() => {
    if (item && file?._id) getFile();
  }, [item, file?._id]);

  const getFilesData = async (fileId: any) => {
    try {
      if (fileId && item) {
        setFetchFileLoader(true);
        const response: any = await appRequest("document", "previewDocument", { fileId });
        if (response && response.base64) {
          const contentType = response.contentType || file.metadata?.contentType || "application/pdf";
          const blob = base64ToBlob(response.base64, contentType);
          const fileURL = URL.createObjectURL(blob);
          setSample({ url: fileURL, file: file, type: contentType, buffer: null, base64: response.base64 });
        }
      }
    } catch (error: any) {
      toastNotify({ title: "Error", message: error.message, type: "error" });
    } finally {
      setFetchFileLoader(false);
    }
  };

  return (
    <>
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="full">
        <DrawerOverlay />
        <DrawerContent maxW={viewerWidth ? width : "100vw"}>
          <DrawerHeader borderBottomWidth="1px" pb={3}>
            <Flex align="center" gap={6}>
              <Flex align="center" gap={3}>
                <Text fontSize="lg" fontWeight="semibold">Emerging Documents</Text>
                {item?.approval && item?.approval?.length > 0 && item?.approval?.[0]?.name && (
                  <Text fontSize="md" color="gray.600">— {item.approval[0].name}</Text>
                )}
              </Flex>

            </Flex>
          </DrawerHeader>
          <DrawerCloseButton />
          <DrawerBody height="95vh" p={{ base: 2, lg: 4 }}>
            <Grid templateColumns={{ base: "1fr", lg: isExpanded ? "1fr" : "35% 65%" }} gap={isExpanded ? 0 : 4} width="100%" height="100%" minHeight="0">
              <GridItem minW="0" overflow="hidden" display={isExpanded ? "none" : "flex"} flexDirection="column" position="relative">
                {asInitiator ? (
                  <Tabs isFitted variant="unstyled" flex={1} display="flex" flexDirection="column">
                    <TabList bg="gray.50" p={2} borderRadius="sm" gap={1} flexShrink={0}>
                      {file?._id && (
                        <Tab fontSize="xs" fontWeight="600" borderRadius="lg" _selected={{ bg: "teal.500", color: "white" }}>
                          Invoice Document
                        </Tab>
                      )}
                      {DOC_SLOTS.map((d) => (
                        <Tab key={d.key} fontSize="xs" fontWeight="600" borderRadius="lg" _selected={{ bg: "teal.500", color: "white" }}>
                          {d.label}
                          {d.required && <Badge ml={2} colorScheme="red">*</Badge>}
                        </Tab>
                      ))}
                    </TabList>
                    <TabPanels flex={1} overflow="hidden" mt={2}>
                      {file?._id && (
                        <TabPanel p={0} height="100%" display="flex" flexDirection="column">
                          <Box flex={1} position="relative" overflow="hidden">
                            {fetchFileLoader ? (
                              <Box flex={1} display="flex" alignItems="center" justifyContent="center">
                                <Spinner size="xl" thickness="4px" speed="0.65s" color="teal.400" />
                              </Box>
                            ) : (
                              <FileViewer activePage={activePage} sample={sample} docId={docId} recallApi={(fileId: any) => { handleGet(); getFilesData(fileId) }} />
                            )}
                          </Box>
                        </TabPanel>
                      )}
                      {DOC_SLOTS.map((d) => (
                        <TabPanel key={d.key} p={0} height="100%" display="flex" flexDirection="column">
                          <Flex justify="space-between" align="center" px={3} py={2} flexShrink={0}>
                            {fileSlots[d.key] && <Badge colorScheme="teal">{fileSlots[d.key]?.name}</Badge>}
                            {fileSlots[d.key] && <IconButton size="xs" aria-label="remove" icon={<CloseIcon />} onClick={() => removeFile(d.key)} />}
                          </Flex>
                          {!fileSlots[d.key] && (
                            <Box px={3} pb={2} flexShrink={0}>
                              <Input type="file" accept=".pdf" onChange={(e) => handleSlotChange(e, d.key)} />
                            </Box>
                          )}
                          {previews[d.key] && (
                            <Box flex={1} border="1px solid gray.200" overflow="hidden">
                              <FileViewer sample={{ url: previews[d.key]!, name: fileSlots[d.key]?.name, type: fileSlots[d.key]?.type || "application/pdf", file: fileSlots[d.key], buffer: null }} />
                            </Box>
                          )}
                        </TabPanel>
                      ))}
                    </TabPanels>
                  </Tabs>
                ) : (
                  file?._id && item ? (
                    fetchFileLoader ? (
                      <Box flex={1} display="flex" alignItems="center" justifyContent="center">
                        <Spinner size="xl" thickness="4px" speed="0.65s" color="teal.400" />
                      </Box>
                    ) : (
                      <Box flex={1} position="relative" overflow="hidden">
                        <FileViewer activePage={activePage} sample={sample} docId={docId} recallApi={(fileId: any) => { handleGet(); getFilesData(fileId) }} />
                      </Box>
                    )
                  ) : (
                    <Tabs isFitted variant="unstyled" flex={1} display="flex" flexDirection="column">
                      <TabList bg="gray.50" p={2} borderRadius="sm" gap={1} flexShrink={0}>
                        {DOC_SLOTS.map((d) => (
                          <Tab key={d.key} fontSize="xs" fontWeight="600" borderRadius="lg" _selected={{ bg: "teal.500", color: "white" }}>
                            {d.label}
                            {d.required && <Badge ml={2} colorScheme="red">*</Badge>}
                          </Tab>
                        ))}
                      </TabList>
                      <TabPanels flex={1} overflow="hidden" mt={2}>
                        {DOC_SLOTS.map((d) => (
                          <TabPanel key={d.key} p={0} height="100%" display="flex" flexDirection="column">
                            <Flex justify="space-between" align="center" px={3} py={2} flexShrink={0}>
                              {fileSlots[d.key] && <Badge colorScheme="teal">{fileSlots[d.key]?.name}</Badge>}
                              {fileSlots[d.key] && <IconButton size="xs" aria-label="remove" icon={<CloseIcon />} onClick={() => removeFile(d.key)} />}
                            </Flex>
                            {!fileSlots[d.key] && (
                              <Box px={3} pb={2} flexShrink={0}>
                                <Input type="file" accept=".pdf" onChange={(e) => handleSlotChange(e, d.key)} />
                              </Box>
                            )}
                            {previews[d.key] && (
                              <Box flex={1} border="1px solid gray.200" overflow="hidden">
                                <FileViewer sample={{ url: previews[d.key]!, name: fileSlots[d.key]?.name, type: fileSlots[d.key]?.type || "application/pdf", file: fileSlots[d.key], buffer: null }} />
                              </Box>
                            )}
                          </TabPanel>
                        ))}
                      </TabPanels>
                    </Tabs>
                  )
                )}
              </GridItem>
              <GridItem minW="0" overflow="hidden" display={"block"} position="relative">
                <Box position="absolute" top={2} right={2} zIndex={100}>
                  <IconButton aria-label={isExpanded ? "Collapse" : "Expand"} icon={isExpanded ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 14h6v6" /><path d="M20 10h-6V4" /><path d="M14 10l7-7" /><path d="M3 21l7-7" /></svg> : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 3h6v6" /><path d="M9 21H3v-6" /><path d="M21 3l-7 7" /><path d="M3 21l7-7" /></svg>} size="sm" colorScheme="teal" onClick={() => setIsExpanded(!isExpanded)} opacity={0.8} _hover={{ opacity: 1 }} />
                </Box>
                <Box border="1px solid teal" borderRadius={8} p={{ base: 3, lg: 4 }} height="100%" overflowY="auto">
                  <EmergingForm item={item} gstUser={accountDetails?.level === "level-2"} showTds={accountDetails?.level === "admin" || Number(accountDetails?.level?.split("-")?.[1] || 0) > 3} disabledOtherUserField={!item?.documentId ? false : accountDetails?.level?.split("-")[1] > 2} tdsFifthApproval={accountDetails?.level === "admin" || Number(accountDetails?.level?.split("-")?.[1] || 0) > 4} value={invoiceDetails} onChange={(data: any) => { if (!Object.keys(originalDetails).length) setOriginalDetails(data); setInvoiceDetails(data); }} workflowProcess={workflowProcess} validationErrors={validationErrors} />
                </Box>
              </GridItem>
            </Grid>
          </DrawerBody>
          <DrawerFooter display={(name === "Pending Approval" || asInitiator) ? undefined : "none"}>
            <Flex gap={3}>
              <Button colorScheme="green" onClick={() => { setDecisionType("approved"); setDecisionDrawerOpen(true); }}>{asInitiator ? "Initiate Workflow" : "Accepted"}</Button>
              {!asInitiator && <Button display={documentId ? accountDetails?.level === "admin" ? "none" : undefined : 'none'} colorScheme="red" onClick={() => { setDecisionType("rejected"); setDecisionDrawerOpen(true); }}>Rejected</Button>}
            </Flex>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
      <Drawer isOpen={decisionDrawerOpen} placement="bottom" onClose={() => setDecisionDrawerOpen(false)} size="md">
        <DrawerOverlay backdropFilter="blur(3px)" />
        <DrawerContent borderTopRadius="2xl" p={1}>
          <DrawerHeader borderBottomWidth="1px" pb={3}>
            <Flex align="center" justify="space-between">
              <Text fontSize="lg" fontWeight="semibold">{decisionType === "approved" ? "Approval Confirmation" : "Rejection Confirmation"}</Text>
              <DrawerCloseButton position="static" />
            </Flex>
          </DrawerHeader>
          <DrawerBody pt={4}>
            <FormControl>
              <FormLabel fontWeight="medium">Comment</FormLabel>
              <Textarea placeholder="Please enter your comment..." value={comment} onChange={(e) => setComment(e.target.value)} resize="none" borderRadius="lg" focusBorderColor={decisionType === "approved" ? "green.400" : "red.400"} />
            </FormControl>
          </DrawerBody>
          <DrawerFooter borderTopWidth="1px">
            <Flex w="100%" justify="flex-end" gap={3}>
              <Button variant="outline" onClick={() => setDecisionDrawerOpen(false)}>Cancel</Button>
              <Button colorScheme={decisionType === "approved" ? "green" : "red"} isLoading={loading} onClick={() => submitDecision("yes")} minW="120px">{decisionType === "approved" ? "Approve" : "Reject"}</Button>
            </Flex>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
      {/* Master Document Modal Removed */}
    </>
  );
}
